import { action, computed, observable } from "mobx";
import UserRepository from "~/repository/UserRepository";

class LoginStore {
  /**
   * @property {UserRepository}
   */
  userRepository;

  /**
   * @type {string}
   */
  @observable username = "";

  /**
   * @type {string}
   */
  @observable password = "";

  /**
   * @type {boolean}
   */
  @observable isRememberMe = false;

  /**
   * @type {boolean}
   */
  @observable isLoginIn = false;

  /**
   * @type {boolean}
   */
  @observable isLoginOut = false;

  /**
   * @type {boolean}
   */
  @observable isRedirecting = false;

  /**
   * @type {boolean}
   */
  @observable isLoginError = false;

  /**
   * @type {boolean}
   */
  @observable hasLoggedOut = false;

  /**
   * @type {string}
   */
  @observable loginErrorMessage = "";

  @computed
  get canLogin() {
    return this.username.length > 0 && this.password.length >= 4;
  }

  constructor() {
    this.userRepository = new UserRepository();
  }

  @action
  reset() {
    this.isLoginError = false;
    this.loginErrorMessage = "";
    this.username = "";
    this.password = "";
    this.isRememberMe = false;
  }

  redirectLoggedUser(continueURL, type) {
    this.isRedirecting = true;

    if (continueURL.length > 0) {
      window.location = continueURL;
      return;
    }

    switch (type) {
      case "Provider":
        window.location = "/panel/tour";
        break;
      default:
        window.location = "/panel/tour";
        break;
    }
  }

  @action
  logout() {
    this.isLoginOut = true;

    return this.userRepository.logout().finally(() => {
      this.isLoginOut = false;
      this.hasLoggedOut = true;
    });
  }

  @action
  login(continueURL) {
    this.isLoginIn = true;
    this.isLoginError = false;
    this.hasLoggedOut = false;

    return this.userRepository
      .login({
        username: this.username,
        password: this.password,
        rememberMe: this.isRememberMe,
      })
      .then(data => {
        this.redirectLoggedUser(continueURL || data.data.continueURL);
      })
      .catch(data => {
        this.isLoginError = true;
        this.loginErrorMessage = data.errors.authentication;
      })
      .finally(() => {
        this.isLoginIn = false;
      });
  }
}

export default LoginStore;
